import { render } from "./Trail.vue?vue&type=template&id=5f789f2e&scoped=true"
import script from "./Trail.vue?vue&type=script&lang=js"
export * from "./Trail.vue?vue&type=script&lang=js"

import "./Trail.vue?vue&type=style&index=0&id=5f789f2e&lang=scss&scoped=true"

import exportComponent from "/proyectos/programas-de-investigacion/scga-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f789f2e"]])

export default __exports__